"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const theme_1 = require("@icr-ui/theme");
const icons_1 = require("@icr-ui/icons");
const styles_1 = require("./styles");
const utils_1 = require("@icr-ui/utils");
exports.Checkbox = (0, react_1.forwardRef)((props, ref) => {
    const { label, error, disabled, isSelected, setIsSelected, messageStatus = 'Message Status', ...rest } = props;
    const defaultMessageStatus = error ? messageStatus : undefined;
    const WrapperComponent = !disabled
        ? !error
            ? styles_1.StyledMasterCheckboxWrapper
            : styles_1.StyledErrorCheckboxWrapper
        : styles_1.StyledDisabledCheckboxWrapper;
    const handleClick = () => {
        !disabled && setIsSelected(!isSelected);
    };
    return ((0, jsx_runtime_1.jsxs)(WrapperComponent, { "data-testid": "checkbox-wrapper", alignItems: "flex-start", ...{ isSelected, error, disabled, ref }, children: [(0, jsx_runtime_1.jsxs)(styles_1.StyledCheckboxWrapper, { flexDirection: "row", alignItems: "center", onClick: () => handleClick(), children: [(0, jsx_runtime_1.jsx)(styles_1.StyledSquareCheckbox, { "data-testid": `square-checkbox${isSelected ? '-true' : '-false'}`, children: (0, jsx_runtime_1.jsx)(icons_1.CheckmarkIcon, { width: (0, utils_1.pxToRem)(8), height: (0, utils_1.pxToRem)(8), color: theme_1.palette.grayScale[50], strokeWidth: 4 }) }), (0, jsx_runtime_1.jsxs)(styles_1.StyledLabelCheckbox, { "data-testid": "label-checkbox", variant: "body", size: "small", weight: "medium", colorScheme: {
                            type: 'text',
                            color: 'label',
                        }, children: [(0, jsx_runtime_1.jsx)(styles_1.StyledInputCheckbox, { "data-testid": "input-checkbox", checked: isSelected, onChange: () => setIsSelected(!isSelected), ...rest }), label] })] }), defaultMessageStatus && ((0, jsx_runtime_1.jsx)(styles_1.StyledMessageStatus, { variant: "body", size: "small", "data-testid": "message-status", colorScheme: {
                    type: 'text',
                    color: 'label',
                }, weight: "medium", children: defaultMessageStatus }))] }));
});
exports.Checkbox.displayName = 'Checkbox';
exports.default = exports.Checkbox;
//# sourceMappingURL=checkbox.js.map